import { useFormatting } from "@msys/ui";
import type { GridColDef } from "@mui/x-data-grid-premium";
import React from "react";
import type { EstimatedCalculation__ItemFragment } from "../../doc-items/boxes/EstimatedCalculationBox.generated.js";
import type { DocDataGrid_ItemFragment } from "../DocDataGrid.generated.js";
import type { DocDataGridRow } from "../types.js";

function FactorCell({ factor }: { factor: number }) {
  const { getFormattedFloat } = useFormatting();
  if (factor === 1) return null;
  return <span>×{getFormattedFloat(factor)}</span>;
}

interface Options {
  headerName: string;
}

export function createMaterialFactorColumn<
  T extends DocDataGrid_ItemFragment & EstimatedCalculation__ItemFragment,
>(options: Options): GridColDef<DocDataGridRow<T>> {
  return {
    field: "materialFactor",
    headerName: options.headerName,
    width: 70,
    editable: false,
    sortable: false,
    filterable: false,
    valueGetter: (_value, row) =>
      row.item?.proposedCalculation?.materialFactor ?? 1,
    renderCell: params => {
      if (params.row.kind === "input" || !params.row.item) return null;
      if (params.row.item.type !== "paid") return null;
      return <FactorCell factor={params.value ?? 1} />;
    },
  };
}
